import { clearCurrentUserFromSession } from '../../../webmodule-common/other/user-session-verifier';
import { customElement } from 'lit/decorators.js';
import { getApi } from '../../api/api-injector';
import { getCurrentUser } from '../../../webmodule-common/other/api/current-user';
import { getInternalId } from '../../../webmodule-common/other/ui/databinding/databinding';
import { goStaticURL } from '../../../webmodule-common/other/ui/resource-resolver';
import { html } from 'lit';
import { PageBase } from './helpers/page-base';

@customElement('app-login')
export class AppLogin extends PageBase {
  internalId: string = getInternalId();
  // For more information on using properties and state in lit
  // check out this link https://lit.dev/docs/components/properties/
  constructor() {
    super();
  }

  protected divertToLogin(): boolean {
    return false; //we are the login
  }

  /** Login has no branch context yet — skip the available-branches gate. */
  protected requiresAvailableBranches(): boolean {
    return false;
  }
  loginEvent = async () => {
    try {
      await this.performLoginProcess();
    } catch (e) {
      //
    }
    //
  };
  login() {
    setTimeout(this.loginEvent, 100);
  }
  private get elementId(): string {
    return `login-page-${this.internalId}`;
  }

  protected async awaken() {
    //if we ever reach this page and we are not logged in
    //then we want to force a page reload which will
    //take us through our full reload process of the apoplication
    //in index.html including the user login process
    if (this.loggedIn) goStaticURL('');
    else this.login();
  }
  async dispose() {
    super.dispose();
  }
  async performLoginProcess() {
    clearCurrentUserFromSession();
    if (getCurrentUser() == null) {
      await getApi().performAuthenticationProcess();
      if (getCurrentUser() !== null) {
        goStaticURL('');
      } else this.login();
    } else goStaticURL('');
    return true;
  }

  render() {
    return html`
      <div id=${this.elementId} class="page-content">
        <div class="page-container"></div>
      </div>
    `;
  }
  meta() {
    return {
      title: 'SoftTech Dealer',
      titleTemplate: null,
      description: 'SoftTech dealer CPQ'
    };
  }
}
